import { WizardSideNav } from "../../../../common/wizard/WizardSideNav";
import { useBidStepLabel, visibleBidSteps, type BidStep, type BidStepVisibility } from "./bidWizardSteps";

interface Props {
  currentStep: BidStep;
  navigateToStep: (step: BidStep) => void;
  visibility: BidStepVisibility;
}

export const BidWizardNav = ({ currentStep, navigateToStep, visibility }: Props) => (
  <WizardSideNav
    steps={visibleBidSteps(visibility)}
    currentStep={currentStep}
    navigateToStep={navigateToStep}
    stepLabel={useBidStepLabel()}
  />
);
